/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No fonts added yet. Add system fonts above to use in your captions." |
*
* @param {Options_Fonts_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_empty_state = /** @type {((inputs?: Options_Fonts_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune police ajoutée. Ajoutez des polices système ci-dessus pour vos sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden noch keine Schriftarten hinzugefügt. Fügen Sie oben Systemschriftarten hinzu, die Sie in Ihren Bildunterschriften verwenden möchten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun font aggiunto ancora. Aggiungi i font di sistema qui sopra da utilizzare nelle didascalie.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Шрифты пока не добавлены. Добавьте системные шрифты выше, чтобы использовать их в подписях.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se han añadido fuentes. Añade las fuentes del sistema arriba para usarlas en tus subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尚未添加任何字体。请在上方添加系统字体，以便在字幕中使用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("まだフォントが追加されていません。キャプションで使用するには、上記のシステムフォントを追加してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई फ़ॉन्ट नहीं जोड़ा गया है। अपने कैप्शन में उपयोग करने के लिए ऊपर दिए गए सिस्टम फ़ॉन्ट जोड़ें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma fonte foi adicionada ainda. Adicione fontes do sistema acima para usar em suas legendas.")
	return /** @type {LocalizedString} */ ("No fonts added yet. Add system fonts above to use in your captions.")
});